export default Object.freeze({
  UPLOAD_FAIL: 'UPLOAD_FAIL',
  UPLOAD_SUCCESS: 'UPLOAD_SUCCESS',
});
